type TKeyPoint = {
  value: string;
  mark: string;
  caption: string;
};

export const KeyPoint = ({value, mark, caption}: TKeyPoint) => (
  <div>
    <span className="font-oswald text-5xl tracking-wide">
      <span>{value}</span>
      <span className="text-action ml-1">{mark}</span>
    </span>

    <h4 className="font-roboto tracking-wider text-base text-neutral-500">{caption}</h4>
  </div>
);
